export const mutationTypes = {
    PRODUCTS_ADD: 'PRODUCTS_ADD',
    PRODUCTS_CREATE: 'PRODUCTS_CREATE',
    PRODUCTS_UPDATE: 'PRODUCTS_UPDATE',
    PRODUCTS_UPDATE_POSITIONS: 'PRODUCTS_UPDATE_POSITIONS',
    PRODUCTS_DELETE: 'PRODUCTS_DELETE',
    PRODUCTS_FILES_LOAD: 'PRODUCTS_FILES_LOAD',
	PRODUCTS_FILES_CREATE: 'PRODUCTS_FILES_CREATE',
	PRODUCTS_FILES_UPDATE: 'PRODUCTS_FILES_UPDATE',
	PRODUCTS_FILES_DELETE: 'PRODUCTS_FILES_DELETE',
    PRODUCTS_WIPE: 'PRODUCTS_WIPE',
    PRODUCTS_VALIDATION_ERRORS: 'PRODUCTS_VALIDATION_ERRORS',
	PRODUCTS_VALIDATION_CLEAR: 'PRODUCTS_VALIDATION_CLEAR',
    PRODUCTS_VALIDATION_MODAL: 'PRODUCTS_VALIDATION_MODAL',	
    PRODUCTS_BRANDS_LOAD: 'PRODUCTS_BRANDS_LOAD',
    PRODUCTS_BRANDS_CREATE: 'PRODUCTS_BRANDS_CREATE',
    PRODUCTS_BRANDS_UPDATE: 'PRODUCTS_BRANDS_UPDATE',
    PRODUCTS_BRANDS_DELETE: 'PRODUCTS_BRANDS_DELETE'
}

export default {
    [mutationTypes.PRODUCTS_ADD]: (state, data) => {
        if (Array.isArray(data))
            state.products = data
        else    
            state.products.push(data)
    },
    [mutationTypes.PRODUCTS_CREATE]: (state, product) => {
        state.products.push(product)
    },
    [mutationTypes.PRODUCTS_UPDATE]: (state, product) => {
        const i = state.products.findIndex(temp => temp.id == product.id)
        state.products[i] = product
        state.products = [...state.products]
    },
    [mutationTypes.PRODUCTS_UPDATE_POSITIONS]: (state, positions) => {
        positions.forEach(tempPosition => {
            const i = state.products.findIndex(tempProduct => tempPosition.productId == tempProduct.id)
            state.products[i].position = tempPosition.position
        })
        state.products = [...state.products]
    },    
    [mutationTypes.PRODUCTS_DELETE]: (state, product) => {
        const i = state.products.findIndex(temp => temp.id == product.id)
        state.products.splice(i,1)        
    },
    [mutationTypes.PRODUCTS_FILES_LOAD](state, data) {
		state.productsFiles = data
	},
	[mutationTypes.PRODUCTS_FILES_CREATE](state, productFile) {
		state.productsFiles.push(productFile)
	},
	[mutationTypes.PRODUCTS_FILES_UPDATE](state, productFile) {
		const i = state.productFiles.findIndex(item => item.id == productFile.id)
		Vue.set(state.productsFile, i, productFile) 
	},
	[mutationTypes.PRODUCTS_FILES_DELETE](state, productFile) {
		const i = state.productsFiles.findIndex(temp => temp.id == productFile.id)
		state.productsFiles.splice(i,1)
	},
    [mutationTypes.PRODUCTS_VALIDATION_ERRORS](state, data) {		
		state.productsValidationErrors = data
	},
	[mutationTypes.PRODUCTS_VALIDATION_CLEAR](state) {		
		state.productsValidationErrors = false
	},
	[mutationTypes.PRODUCTS_VALIDATION_MODAL](state, data) {		
		state.productsValidationModal = data
	},	
    [mutationTypes.PRODUCTS_WIPE]: state => {
        state.products = [] 
    },
    [mutationTypes.PRODUCTS_BRANDS_LOAD](state, brands) {
		state.productsBrands = brands
    },
    [mutationTypes.PRODUCTS_BRANDS_CREATE](state, brand) {
		state.productsBrands.push(brand)
    },
    [mutationTypes.PRODUCTS_BRANDS_UPDATE](state, brand) {
        const i = state.productsBrands.findIndex(temp => temp.id == brand.id)
        state.productsBrands[i] = brand
        state.productsBrands = [...state.productsBrands]
	},
	[mutationTypes.PRODUCTS_BRANDS_DELETE](state, brand) {
		const i = state.productsBrands.findIndex(temp => temp.id == brand.id)
		state.productsBrands.splice(i,1)
	}
}